var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      { staticClass: "mobile-link", class: { open: _vm.active } },
      _vm.$listeners
    ),
    [
      _c("span", { staticClass: "link-label" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("span", { staticClass: "item_switch" }),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "loader" }) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }